import React from 'react';
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    popover: {
        zIndex: '10002 !important'
    },
    paper: {
        zIndex: '10002 !important'
    }
});

function ToolPopOver({ isOpen, element, handleClose, children }) {
    const id = isOpen ? 'simple-popover' : undefined;
    const classes = useStyles();

    return (
        <Box>
            <Popover
                id={id}
                open={isOpen}
                anchorEl={element.current}
                onClose={() => handleClose()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                className={classes.popover}
                classes={{
                    paper: classes.paper
                }}
                BackdropProps={{
                    invisible: true
                }}
            >
                <Box m={1}>{children}</Box>
            </Popover>
        </Box>
    );
}

ToolPopOver.propTypes = {
    element: PropTypes.any,
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    children: PropTypes.node
};

export default ToolPopOver;
